<app-card [loading]="loading">
  @if (!loading) {
    <div class="center">
      <div>
        <img class="img" [src]="config.image" alt="" />
      </div>
      <p>{{ config.headline | translate }}</p>
      <a [href]="config.buttonLink" class="button primary-button">
        {{ config.buttonLabelKey | translate }}
      </a>
    </div>
  }
</app-card>
